import { Link } from 'react-router';
import { useSession } from '../auth/session';
import { EmptyState } from '../components/ui';
import { ThemeToggle } from '../components/ThemeToggle';
import { InvitationsCard } from '../library/InvitationsCard';
import { useMyInvitations } from '../library/invitationQueries';

/**
 * Where the invitation emails land.
 *
 * The links carry no token, so this page shows whatever is addressed to the confirmed address of
 * whoever is signed in — which is why arriving here signed in as somebody else shows nothing
 * rather than somebody else's invitation.
 */
export function InvitationsPage() {
  const { data: me } = useSession();
  const invitations = useMyInvitations();

  const nothingWaiting = !invitations.isPending && (invitations.data ?? []).length === 0;

  return (
    <div className="flex h-full flex-col bg-surface">
      <header className="flex items-center justify-between border-b border-border-subtle px-6 py-3">
        <div className="flex items-center gap-3">
          <Link to="/" className="text-sm text-text-muted hover:text-text">
            ← Back to drawer
          </Link>
          <h1 className="text-sm font-semibold text-text">Invitations</h1>
        </div>
        <ThemeToggle />
      </header>

      <main className="min-h-0 flex-1 overflow-y-auto p-6">
        <div className="flex max-w-2xl flex-col gap-4">
          <InvitationsCard heading={false} />

          {nothingWaiting && (
            <EmptyState title="Nothing waiting for you">
              {me?.emailConfirmed
                ? `Invitations sent to ${me.email} will appear here.`
                : 'Confirm your email address and any invitations sent to it will appear here.'}
            </EmptyState>
          )}
        </div>
      </main>
    </div>
  );
}
